import type { ResolvedUvInserts } from "./resolve-uv-inserts"

/**
 * Returns the description string declared on a UV insert config in uv-inserts-config.liquid,
 * given its handle. Returns null when the config is not found or has no description.
 *
 * Used by OptionSelectionRoute to override option subtitles with MVVM-sourced strings,
 * removing all window.giftWrapData reads from pages.js subtitle functions.
 *
 * Pure function — no window access.
 */
export function getUvInsertConfigDescription(options: {
  configHandle: string
  resolved: ResolvedUvInserts
}): string | null {
  const { configHandle, resolved } = options
  const config = resolved.configs.find((c) => c.handle === configHandle)
  return config?.description ?? null
}
